import { PromiseCardData } from '../types';

// Committed to Security Section Data
export const COMMITTED_TO_SECURITY_DATA = {
  heading: 'Committed to security',
  description: `We value your data as if it were ours. All our certifications and licenses, including GSP, were
    awarded after rigorous scrutiny of our systems and multiple VAPT audits.`,
  image: {
    webp: 'https://assets1.cleartax-cdn.com/cleartax/images/1620213268_1620036013_security_certificates.webp',
    jpeg: 'https://assets1.cleartax-cdn.com/cleartax/images/1620036013_security_certificates.png',
    alt: 'security_icons',
  },
};

export const DATA_SECURITY_CARDS: PromiseCardData[] = [
  {
    id: 'encryption',
    title: 'Encryption',
    description:
      'Your data is transmitted across SSL certified pathways. We are SOC 2 compliant.',
    src: 'https://assets1.cleartax-cdn.com/cleartax/images/1606110290_encryption.svg',
    alt: 'section_encryption',
  },
  {
    id: 'privacy',
    title: 'Privacy',
    description:
      "We do not share your or your clients' data with unaffiliated third parties for their own purposes.",
    src: 'https://assets1.cleartax-cdn.com/cleartax/images/1606308817_privacyaware.svg',
    alt: 'privacy_section',
  },
  {
    id: 'datastorage',
    title: 'Data Storage',
    description:
      'We use ISO 27001 certified data centres, which are quarterly VAPT tested and externally audited.',
    src: 'https://assets1.cleartax-cdn.com/cleartax/images/1606110503_home_data_storage.svg',
    alt: 'data_storage_img',
  },
];
